import React, { FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';

import { UpdateInputFormat } from 'components';
import { FormGroup } from 'components/chroma';

import { UpdateValueQuestionProps } from 'scenes/common/components/Questions/types';

const UpdateValueQuestion: FunctionComponent<UpdateValueQuestionProps> = ({
  errors,
  control,
  question,
  stateKey,
  ariaLabel,
  defaultValue,
  validationRules,
  helpText,
  helpLink,
  onUpdateClick,
}) => (
  <Controller
    control={control}
    name={stateKey}
    defaultValue={defaultValue}
    rules={validationRules}
    render={({ onChange, value }) => (
      <FormGroup
        id={stateKey}
        label={question}
        error={errors[stateKey]?.message || ''}
        helpText={helpText || ''}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(helpLink && { helpLink })}
      >
        <UpdateInputFormat
          id={stateKey}
          fieldName={stateKey}
          ariaLabel={ariaLabel}
          prefix="$"
          placeholder="$0"
          decimalScale={0}
          value={value}
          onChange={onChange}
          valid={Boolean(value) && !errors[stateKey]?.types?.validField}
          error={Boolean(value) && Boolean(errors[stateKey])}
          onUpdateClick={onUpdateClick}
        />
      </FormGroup>
    )}
  />
);

export default UpdateValueQuestion;
